<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useAuthStore } from '@/stores/auth'

export default {
  name: 'App',
  computed: {
    ...mapStores(useAuthStore)
  },
  data() {
    return {}
  },
  created() {
    try {
      // Initialize auth store
      const authStore = this.authStore

      // Check authentication on app start
      const token = localStorage.getItem('token')
      const user = localStorage.getItem('user')
      const publicPaths = ['/login', '/privacy-policy', '/terms-of-service', '/contact', '/facebook-oauth-callback']
      if (!token && !publicPaths.includes(this.$route.path)) {
        this.$router.push('/login')
        return
      }
      if (token && user) {
        try {
          authStore.token = token
          authStore.user = JSON.parse(user)
          authStore.permissions = authStore.user.permissions || []
          authStore.isAuthenticated = true
        } catch (parseError) {
          console.error('Failed to parse user data:', parseError)
          authStore.logout()
        }
      }
      // On refresh: call /api/user to sync user and permissions
      if (token) {
        authStore.refreshUserData()
      }
      // Redirect logic
      if (token && this.$route.path === '/login') {
        this.$router.push('/admin/dashboard')
      }
    } catch (error) {
      console.error('Error in App.vue created:', error)
      this.$router.push('/login')
    }
  }
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
}

#app {
  height: 100%;
  min-height: 100vh;
}
</style>